// extracted by mini-css-extract-plugin
export default {"baseClass":"interactive-cards"};